import React from 'react';
import { ProjectInstallationSummaryRow } from 'modules/components/layer23';
import { StyledTable } from 'modules/components/layer24';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';


export type ProjectInstallationSummaryTableProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectInstallationSummaryTableProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  const headers = [
    'Selection name',
    'Remaining Selections',
    'Completed Selections',
    ''
  ];

  const tempRows = data.map((node, i) => (
    <ProjectInstallationSummaryRow.FC
      key={i}
      id={node.id}
      type={node.type}
      projectId={params.projectId ?? ''}
      numberOfActiveInstallations={node.numberOfActiveDecisionsInstallations}
      numberOfCompletedInstallations={node.numberOfApprovedInstallations}
    />
  ));

  return (
    <StyledTable.FC
      headers={headers}
      rows={tempRows}
    />
  );
};
